export const LIST = 'LIST'
export const REQUEST_TO_CLOSE = 'REQUEST_TO_CLOSE'